module.exports = __webpack_public_path__ + "static/media/qmo_loader.85056999.gif";